<template>
    <div>
        <router-link :to="{ name: 'Recipes', params: { id: recipe.id }}">
            <transition name="fade" appear>
                <div class='tile'>
                    <div class='top' v-if="imgLoaded" v-bind:style="{ background: 'url(' + jpeg + ') 0px 0px / 100% no-repeat, linear-gradient(to top, rgba(0,0,0,0.5), rgba(0,0,0,0.0))' }">
                        <div class='title'>{{ recipe.title }}</div>
                        <div @click.prevent="publish" v-if='publishedSet' class='published'>
                            <img v-bind:class="[ recipe.published ? 'active' : 'inactive']" src="../assets/verified-white-18dp.svg">
                        </div>
                        <div @click.prevent="edit" v-if='publishedSet' class='edit'>
                            <img class="active" src="../assets/edit-white-18dp.svg">
                        </div>
                    </div>
                    <div class='bottom'>
                        <div class='details'>
                            <div class='author'><img alt="author" src="../assets/person-black-18dp.svg">{{ recipe.author }}</div>
                            <div class='description'>{{ recipe.description }}</div>
                            <div class='views'>{{ formatViews(recipe.views) }}</div>
                        </div>
                    </div>
                </div>
            </transition>
        </router-link>
    </div>
</template>

<script>
import axios from 'axios'
import { viewsMixin } from '@/mixins/views.js'
export default {
    name: 'Tile',
    mixins: [ viewsMixin ],
    props: {
        recipe: Object
    },
    data () {
        return {
            imageSize: 640,
            imgLoaded: false
        }
    },
    methods: {
        publish: function () {
            let vm = this
            vm.withAuth(function () {
                var headers = {}
                headers['Authorization'] = 'Bearer ' + vm.$store.getters.id_token
                axios.put('/api/author/publish/' + vm.recipe.id + '/' + !vm.recipe.published, {}, { headers: headers })
                    .then(response => {
                        if (response.data) {
                            console.log(response.data)
                            vm.recipe.published = JSON.parse(response.data.published.toLowerCase())
                        }
                    }
                )
            })
        },
        edit: function () {
            this.$router.push('edit/' + this.recipe.id)
        }
    },
    created: function () {
        let img = new Image();
        img.onload = () => {
            this.imgLoaded = true
        };
        img.src = this.jpeg
    },
    computed: {
        webp() {
            return '/assets/' + this.recipe.id + '/' + this.recipe.id + '-' + this.imageSize + '.webp'
        },
        jpeg() {
            return '/assets/' + this.recipe.id + '/' + this.recipe.id + '-' + this.imageSize + '.jpeg'
        },
        publishedSet() {
            return ( 'published' in this.recipe )
        }
    }
}
</script>

<style scoped>

@media (max-width: 350px) {
    .tile {
        width: 100vw;
    }
}
@media (min-width: 350px) {
    .tile {
        width: 320px;
        margin: 15px;
        box-shadow: 0px 10px 15px 3px rgba(0, 0, 0, 0.10);
    }
}
a {
    text-decoration: none;
}
.top {
    position: relative;
    width: auto;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-right: 0px;
    color: #f5f5f5;
    height: 180px;
    background-blend-mode: multiply;
    background-size: cover;
    padding: 10px;
}
.bottom {
    height: 120px;
    position: relative;
    padding: 12px;
    background-color: #ffffff;
}
.details {
    position: relative;
    width: 100%;
    height: 100%;
}
.title {
    font-size: 1.6em;
    letter-spacing: 0.02em;
    position: absolute;
    bottom: 0px;
    font-family: 'Comfortaa', Arial;
}
.published {
    position: absolute;
    top: 10px;
    right: 10px;
}
.edit {
    position: absolute;
    top: 40px;
    right: 10px;
}
@media (hover: hover) and (pointer: fine) {
    .published :hover {
        transition: opacity 100ms ease-in-out;
        opacity: 0.8;
    }
}
.active {
    opacity: 1;
}
.inactive {
    opacity: 0.3;
}
.author {
    position: absolute;
    top: 0px;
    left: 0px;
    color: #555555;
    font-size: 1em;
    font-weight: 800;
    font-family: 'Comfortaa', Arial;
}
.author img {
    height: 20px;
    margin-top: -5px;
    padding-right: 10px;
    opacity: 0.3;
}
.description {
    position: absolute;
    text-align: justify;
    top: 28px;
    left: 0px;
    color: #000000;
    font-size: 1em;
    font-family: 'Comfortaa', Arial;
}
.views {
    position: absolute;
    bottom: 0px;
    right: 0px;
    color: #666666;
    font-size: 0.8em;
    font-family: 'Comfortaa', Arial;
}
.fade-enter-active {
    transition: opacity 500ms ease-in-out;
}
.fade-enter-to {
    opacity: 1;
}
.fade-enter {
    opacity: 0;
}
</style>